import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import PressStart2PCyrillic from "./PressStart2P-Regular-Cyrillic.woff2";
import PressStart2PLatinExt from "./PressStart2P-Regular-LatinExt.woff2";
import PressStart2PLatin from "./PressStart2P-Regular-Latin.woff2";

export const PressStart2PFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: PressStart2PCyrillic,
    descriptors: { unicodeRange: GOOGLE_FONTS_RANGES.CYRILIC },
  },
  {
    uri: PressStart2PLatinExt,
    descriptors: { unicodeRange: GOOGLE_FONTS_RANGES.LATIN_EXT },
  },
  {
    uri: PressStart2PLatin,
    descriptors: { unicodeRange: GOOGLE_FONTS_RANGES.LATIN },
  },
];
